import { createSelector } from '@ngrx/store';

import { getBecomeACustomerState } from '../../become-a-customer-feature.selector';

export const getFeatureFlags = (flagId: string) =>
  createSelector(getBecomeACustomerState, (state) => {
    return state?.featureFlags?.[flagId];
  });
